import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Section } from "@/components/Section";
import SmartImage from "@/components/SmartImage";

const ACTION_LABELS = {
  "Coming Soon": ["Notify Me", "/register"],
  "Registration Open": ["Register Now", "/register"],
  "Registration Closed": ["Registration Closed", ""],
  "Live": ["Watch Live", ""],
  "Completed": ["See Results", ""],
};

export default function EventDetail() {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/events/${slug}`).then((r) => setEvent(r.data)).catch(() => setErr("Event not found")); }, [slug]);

  if (err) return <div className="max-w-[1000px] mx-auto p-12 text-center text-[#888]">{err}</div>;
  if (!event) return <div className="max-w-[1000px] mx-auto p-12 text-center text-[#888]">Loading…</div>;

  const [ctaLabel, ctaHref] = ACTION_LABELS[event.status] || ["Register", "/register"];

  return (
    <div data-testid="event-detail">
      <section className="relative min-h-[70vh] flex items-end bg-black overflow-hidden border-b border-[#151515]">
        <SmartImage path={event.hero_path || event.poster_path} fallback="ring" alt={event.title} className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 py-16 w-full">
          <div className="type-label text-[#C8102E] mb-4">{event.event_number || event.sport}</div>
          <h1 className="type-h1" data-testid="event-detail-title">{event.title}</h1>
          <div className="mt-5 flex flex-wrap gap-4 text-sm text-[#c9c9c9]">
            <span className="border border-[#2a2a2a] px-3 py-1.5 text-xs">{event.status}</span>
            <span>{event.location}</span>
            {event.date && <span>· {event.date}</span>}
          </div>
          {ctaHref ? (
            <Link to={ctaHref} className="btn-primary mt-8" data-testid="event-cta">{ctaLabel}</Link>
          ) : (
            <button className="btn-secondary mt-8 opacity-70 cursor-not-allowed" disabled data-testid="event-cta">{ctaLabel}</button>
          )}
        </div>
      </section>

      <Section title="Overview" eyebrow="About the event">
        <p className="text-[#c9c9c9] leading-relaxed max-w-3xl">{event.description || "Details coming soon."}</p>
      </Section>

      <Section title="Registration" eyebrow="Weight Categories">
        {event.weight_categories?.length ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {event.weight_categories.map((w) => (
              <div key={w} className="card-ive p-4 font-display text-xl">{w}</div>
            ))}
          </div>
        ) : <div className="text-[#888]">To be announced.</div>}
      </Section>

      <Section title="Rules & Eligibility" eyebrow="Compliance">
        <p className="text-[#c9c9c9] leading-relaxed max-w-3xl">{event.rules || "Official rulebook will be published prior to registration opening."}</p>
      </Section>
    </div>
  );
}
